import React, { useContext, useState } from "react";
import styles from "./ScoreModal.module.css";
import FormSection from "../ChallengeModal/FormSection";
import Modal from "../../../Reusable/Modal/Modal";
import DateTimeModal from "../DateTimeModal/DateTimeModal";
import { MatchContext } from "../../../../createContext/Match/MatchContext";
import SportScoreInput from "./SportScoreInput.js"; // Import the new component
import { useLocation } from "react-router-dom";
const ScoreModal = (props) => {
  const [activeTab, setActiveTab] = useState("scheduled");
  const [matchType, setMatchType] = useState("1on1");
  const [matchName, setMatchName] = useState("");
  const [sport, setSport] = useState("");
  const [venue, setVenue] = useState("");
  const [opponent, setOpponent] = useState([]);
  const [selectedDate, setSelectedDate] = useState({
    day: new Date().getDate(),
    monthName: new Date().toLocaleString("default", { month: "short" }),
    year: new Date().getFullYear(),
    hours: new Date().getHours(),
    minutes: new Date().getMinutes(),
    month: new Date().getMonth(),
  });
  const [scores, setScores] = useState({});
  const [teamName, setTeamName] = useState("");
  const [OppTeamName, setOppTeamName] = useState("");
  const [players, setPlayers] = useState([]);
  const { setScore } = useContext(MatchContext);
  const isDateTime = true;
  const location=useLocation();
  const isHomeRoute = location.pathname === "/home";
  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const dateTimeField = {
    label: "Choose date & time *",
    icon: "🕓",
    inputType: "text",
    value: `${selectedDate.day} ${monthNames[selectedDate.month]} , ${
      selectedDate.hours % 12 === 0 ? 12 : selectedDate.hours % 12
    }:${
      selectedDate.minutes < 10 ? "0" + selectedDate.minutes : selectedDate.minutes
    } ${selectedDate.hours >= 12 ? "PM" : "AM"}`,
    placeholder: "12 Sep 2:00 PM",
    onClick: () => {
      props.handleShowDateModal();
    },
    onChange: () => {},
    readOnly: isDateTime,
  };

  const scheduledFields = [
    {
      label: "Match Name *",
      icon: "🏆",
      inputType: "text",
      placeholder: "Championship Final",
      value: matchName,
      onChange: (e) => setMatchName(e.target.value),
      type: "matches",
      preInput: props?.preInput
    }
  ];

  const unscheduled1on1LeftFields = [
    {
      label: "Choose sport *",
      icon: "🏀",
      inputType: "text",
      placeholder: "Tennis",
      value: sport,
      onChange: (e) => setSport(e.target.value),
      type: "sports"
    },
    {
      label: "Choose venue *",
      icon: "📍",
      inputType: "text",
      placeholder: "AB Stadium, Downton, USA",
      value: venue,
      onChange: (e) => setVenue(e.target.value),
    }
  ];

  const unscheduled1on1RightFields = [
    dateTimeField,
    {
      label: "Choose opponent *",
      icon: "👤",
      inputType: "text",
      placeholder: "@john",
      value: opponent,
      onChange: (e) => setOpponent(e.target.value),
      type: "player"
    }
  ];

  const unscheduledTeamLeftFields = [
    {
      label: "Choose sport *",
      icon: "🏀",
      inputType: "text",
      placeholder: "Tennis",
      value: sport,
      onChange: (e) => setSport(e.target.value),
      type: "sports"
    },
    {
      label: "Choose venue *",
      icon: "📍",
      inputType: "text",
      placeholder: "AB Stadium, Downton, USA",
      value: venue,
      onChange: (e) => setVenue(e.target.value),
    },
    {
      label: "Choose team name *",
      icon: "📋",
      inputType: "text",
      placeholder: "Fisko FC",
      value: teamName,
      onChange: (e) => setTeamName(e.target.value),
    },
    {
      label: "Select Players (1st as Leader) *",
      icon: "👥",
      inputType: "text",
      placeholder: "@john, @batista, @alex",
      value: players,
      onChange: (e) => setPlayers(e.target.value),
      type: "players"
    }
  ];

  const unscheduledTeamRightFields = [
    dateTimeField,
    {
      label: "Choose Opponent's team name *",
      icon: "📋",
      inputType: "text",
      placeholder: "Fisko FC",
      value: OppTeamName,
      onChange: (e) => setOppTeamName(e.target.value),
    },
    {
      label: "Select Opponent (1st as Leader)*",
      icon: "👥",
      inputType: "text",
      placeholder: "@john, @batista, @alex",
      value: opponent,
      onChange: (e) => setOpponent(e.target.value),
      type: "players"
    }
  ];

  const handleScoreChange = (newScores) => {
    setScores(newScores);
  };
  
  const handleSubmit = async () => {
    try {

      if (activeTab === "scheduled") {
        await setScore({
          matchId: matchName._id,
          scores,
        });
      } else {
        const date = new Date(
          selectedDate.year,
          selectedDate.month,
          selectedDate.day,
          selectedDate.hours,
          selectedDate.minutes
        );

        const scoreData = {
          type: matchType,
          sport: sport._id,
          venue,
          date: date.toISOString(),
          scores
        };

        if (matchType === "team") {
          scoreData.team1 = {
            name: teamName,
            participants: players.map(p => p._id)
          };
          scoreData.team2 = {
            name: OppTeamName,
            participants: opponent.map(p => p._id)
          };
        } else {
          scoreData.opponent = opponent._id;
        }

        await setScore(scoreData);
      }
      
      props.onClose();
    } catch (error) {
      console.error("Error submitting score:", error);
    }
  };

  return (
    <>
    {!props.showDateTimeModal && (
    <Modal {...props} widthModalContent={styles.modalContentWidth}>
      <div className={styles.tabs}>
        <button
          className={`${styles.tab} ${activeTab === "scheduled" ? styles.activeTab : ""}`}
          onClick={() => setActiveTab("scheduled")}
        >
          Fisiko Matches
        </button>
        {isHomeRoute && ( // Conditionally render "Unscheduled Matches" tab only for '/home' route
              <button
                className={`${styles.tab} ${activeTab === "unscheduled" ? styles.activeTab : ""}`}
                onClick={() => setActiveTab("unscheduled")}
              >
                Non Fisiko Matches
              </button>
            )}
      </div>

      {activeTab === "scheduled" ? (
        <div className="flex flex-col gap-5">
          {scheduledFields.map((field, index) => (
            <FormSection
              key={index}
              label={field.label}
              icon={field.icon}
              inputType={field.inputType}
              placeholder={field.placeholder}
              value={field.value}
              onChange={field.onChange}
              type={field.type}
              preInput={field?.preInput}
            />
          ))}
          <div className="ml-6">
          {matchName && (
            <SportScoreInput
            sport={matchName?.sport?.name}
            onScoreChange={handleScoreChange}
            scores={scores}
            />
          )}
          </div>
        </div>
      ) : (
        <div>
          <div className={styles.matchTypeToggle}>
            <button
              className={`${styles.matchTypeButton} ${matchType === "1on1" ? styles.active : ""}`}
              onClick={() => setMatchType("1on1")}
            >
              1 on 1
            </button>
            <button
              className={`${styles.matchTypeButton} ${matchType === "team" ? styles.active : ""}`}
              onClick={() => setMatchType("team")}
            >
              Team
            </button>
          </div>

          {matchType === "1on1" ? (
            <div className={styles.formContainer}>
              <div className={styles.formColumn}>
                {unscheduled1on1LeftFields.map((field, index) => (
                  <FormSection
                    key={index}
                    label={field.label}
                    icon={field.icon}
                    inputType={field.inputType}
                    placeholder={field.placeholder}
                    value={field.value}
                    onChange={field.onChange}
                    type={field.type}
                  />
                ))}
              </div>
              <div className={styles.formColumn}>
                {unscheduled1on1RightFields.map((field, index) => (
                  <FormSection
                    key={index}
                    label={field.label}
                    icon={field.icon}
                    inputType={field.inputType}
                    placeholder={field.placeholder}
                    value={field.value}
                    onChange={field.onChange}
                    type={field.type}
                    onClick={field.onClick}
                  />
                ))}
              </div>
            </div>
          ) : (
            <div className={styles.formContainer}>
              <div className={styles.formColumn}>
                {unscheduledTeamLeftFields.map((field, index) => (
                  <FormSection
                    key={index}
                    label={field.label}
                    icon={field.icon}
                    inputType={field.inputType}
                    placeholder={field.placeholder}
                    value={field.value}
                    onChange={field.onChange}
                    type={field.type}
                  />
                ))}
              </div>
              <div className={styles.formColumn}>
                {unscheduledTeamRightFields.map((field, index) => (
                  <FormSection
                    key={index}
                    label={field.label}
                    icon={field.icon}
                    inputType={field.inputType}
                    placeholder={field.placeholder}
                    value={field.value}
                    onChange={field.onChange}
                    type={field.type}
                    onClick={field.onClick}
                  />
                ))}
              </div>
            </div>
          )}

          {sport && (
            <SportScoreInput
              sport={sport.name}
              onScoreChange={handleScoreChange}
              scores={scores}
            />
          )}
        </div>
      )}

      <div className={styles.submitButtonWrapper}>
        <button 
          className={styles.submitButton}
          onClick={handleSubmit}
        >
          Submit Score
        </button>
      </div>
    </Modal>)}
    {props.showDateTimeModal && (<DateTimeModal
          {...props}
          currentDate={selectedDate}
          setCurrentDate={setSelectedDate}
          isDateTime={isDateTime}
          monthNames={monthNames}
          handleShowDateModal={props.handleShowDateModal}
    />)}
    </>
  );
};

export default ScoreModal;